var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: _vm.maskContainer, attrs: { id: "vue-picture-viewer" } },
    [
      _c("flexbox", { staticClass: "perview-header" }, [
        _c("div", { staticClass: "left" }, [
          _vm._v(_vm._s(_vm.imgIndex + 1) + " / " + _vm._s(_vm.imgLength))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "center" }, [
          _vm._v(_vm._s(_vm.bigImgName.slice(0, _vm.bigImgName.indexOf("."))))
        ]),
        _vm._v(" "),
        _c("img", {
          staticClass: "close",
          attrs: { src: require("./img/pre_close.png") },
          on: { click: _vm.closeViewer }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          ref: "imgContainer",
          staticClass: "imgContainer",
          style: _vm.imgContainer
        },
        [
          _vm.bigShowType.isImage
            ? _c("img", {
                ref: "bigImg",
                style: _vm.bigImgStyle,
                attrs: { src: _vm.bigImgUrl, alt: "" }
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.bigShowType.isImage
            ? _c("flexbox", { staticClass: "file-show" }, [
                _c("div", { staticClass: "file-icon" }, [
                  _c("img", { attrs: { src: _vm.bigShowType.icon } })
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "file-handle" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", plain: "" },
                        nativeOn: {
                          click: function($event) {
                            _vm.fileHandle("download")
                          }
                        }
                      },
                      [_vm._v("下载")]
                    )
                  ],
                  1
                )
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("transition", { attrs: { name: "fade" } }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showTips,
                    expression: "showTips"
                  }
                ],
                staticClass: "tips"
              },
              [_vm._v(_vm._s(_vm.tipsText))]
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fixedHandle" },
        [
          _vm.bigShowType.isImage
            ? _c("flexbox", { staticClass: "handleContainer" }, [
                _c("img", {
                  attrs: { src: require("./img/pre_max.png") },
                  on: { click: _vm.enlarge }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: require("./img/pre_min.png") },
                  on: { click: _vm.reduce }
                }),
                _vm._v(" "),
                _c("img", {
                  staticStyle: { padding: "4.5px" },
                  attrs: { src: require("./img/pre_rotate.png") },
                  on: { click: _vm.rotate }
                }),
                _vm._v(" "),
                _c("img", {
                  attrs: { src: require("./img/pre_down.png") },
                  on: {
                    click: function($event) {
                      _vm.downloadImg(_vm.bigImgUrl, _vm.bigImgName)
                    }
                  }
                })
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.imgLength > 1
            ? _c("div", { staticClass: "thumbnailContainer" }, [
                _c(
                  "ul",
                  _vm._l(this.imgData, function(item, index) {
                    return _c(
                      "li",
                      {
                        key: index,
                        ref: "thumbnailItem",
                        refInFor: true,
                        on: {
                          click: function($event) {
                            _vm.switchImgUrl(index, $event)
                          }
                        }
                      },
                      [
                        _vm.isShowImage(item.url)
                          ? _c("img", { attrs: { src: item.url, alt: "" } })
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isShowImage(item.url)
                          ? _c("img", {
                              attrs: {
                                src: _vm.getFileTypeIconWithSuffix(item.url),
                                alt: ""
                              }
                            })
                          : _vm._e()
                      ]
                    )
                  })
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "leftArrowCon",
          on: {
            click: _vm.handlePrev,
            mouseenter: _vm.enterLeft,
            mouseout: _vm.outLeft
          }
        },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.leftArrowShow,
                expression: "leftArrowShow"
              }
            ],
            staticClass: "leftArrow",
            attrs: { src: require("./img/pre_left.png") },
            on: { click: _vm.enlarge }
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "rightArrowCon",
          on: {
            click: _vm.handleNext,
            mouseenter: _vm.enterRight,
            mouseout: _vm.outRight
          }
        },
        [
          _c("img", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.rightArrowShow,
                expression: "rightArrowShow"
              }
            ],
            staticClass: "rightArrow",
            attrs: { src: require("./img/pre_right.png") }
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }